module.exports = __webpack_public_path__ + "static/media/ORAL PATHOLOGY_BDS.dee42493.docx";